export enum DeviceType {
	desktop = 'desktop',
	mobile = 'mobile',
	tablet = 'tablet',
}
